/**
 * IdLink Component
 *
 * Renders a clickable link for object IDs in global ID format.
 * Navigates to the object inspector page when clicked.
 */

import { Link } from './atoms/Link';
import { objUrl } from '../utils/urls';

export interface IdLinkProps {
  /** The global ID to link to (e.g., "us1a", "ph2s") */
  globalId: string;
  /** Object type name for title attribute */
  typeName?: string;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Render a clickable ID link to the object inspector
 */
export function IdLink({ globalId, typeName, className = '' }: IdLinkProps) {
  try {
    const url = objUrl(globalId);
    const title = typeName
      ? `View ${typeName} ${globalId}`
      : `View object ${globalId}`;

    return (
      <Link
        to={url}
        variant="link-primary"
        className={`font-mono text-sm ${className}`.trim()}
        title={title}
      >
        {globalId}
      </Link>
    );
  } catch (error) {
    // Invalid global ID - render as plain text with error styling
    return (
      <span className={`font-mono text-sm text-destructive ${className}`.trim()}>
        {globalId}
      </span>
    );
  }
}
